function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".stopa{fill:#d56868;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-582.272 -7401)"
}, /*#__PURE__*/React.createElement("path", {
  className: "stopa",
  d: "M599.272,7403.429A14.571,14.571,0,1,1,584.7,7418a14.587,14.587,0,0,1,14.571-14.571m0-2.429a17,17,0,1,0,17,17,17,17,0,0,0-17-17Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(587.129 7405.857)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "stopa",
  d: "M606.415,7413a12.143,12.143,0,1,0,12.143,12.143A12.143,12.143,0,0,0,606.415,7413Zm5.311,15.737a1.214,1.214,0,0,1-1.717,1.717l-3.594-3.594-3.594,3.594a1.214,1.214,0,0,1-1.717-1.717l3.594-3.594-3.594-3.594a1.214,1.214,0,1,1,1.717-1.717l3.594,3.594,3.594-3.594a1.214,1.214,0,0,1,1.717,1.717l-3.594,3.594Z",
  transform: "translate(-594.272 -7413)"
}), /*#__PURE__*/React.createElement("path", {
  className: "stopa",
  d: "M606.415,7415.429a9.663,9.663,0,0,1,5.659,1.822,3.655,3.655,0,0,0-3.782.864l-1.877,1.876-1.876-1.876a3.655,3.655,0,0,0-3.783-.864,9.662,9.662,0,0,1,5.659-1.822m-7.892,4.055a3.653,3.653,0,0,0,.863,3.783l1.877,1.876-1.876,1.876a3.653,3.653,0,0,0-.864,3.783,9.7,9.7,0,0,1,0-11.318m15.783,0a9.7,9.7,0,0,1,0,11.317,3.652,3.652,0,0,0-.863-3.782l-1.877-1.877,1.876-1.876a3.651,3.651,0,0,0,.864-3.782m-7.892,10.811,1.876,1.875a3.652,3.652,0,0,0,3.783.864,9.7,9.7,0,0,1-11.318,0,3.652,3.652,0,0,0,3.782-.864l1.876-1.876m0-17.295a12.143,12.143,0,1,0,12.143,12.143A12.143,12.143,0,0,0,606.415,7413Zm0,10.426,3.594-3.594a1.214,1.214,0,0,1,1.717,1.717l-3.594,3.594,3.594,3.594a1.214,1.214,0,0,1-1.717,1.717l-3.594-3.594-3.594,3.594a1.214,1.214,0,0,1-1.717-1.717l3.594-3.594-3.594-3.594a1.214,1.214,0,0,1,1.717-1.717l3.594,3.594Z",
  transform: "translate(-594.272 -7413)"
}))));

var SvgCircleClose = function SvgCircleClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circleClose.445d690c.svg";
export { ForwardRef as ReactComponent };